import React from 'react';

import './PageError.scss';

export const PageError: React.FC<{ message: string }> = props => {
    return <div className='page-error'>{props.message}</div>;
};
